module.exports = __webpack_public_path__ + "img/trainroomsl.1f30a606.png";